import ContentLayout from '@/layouts/content-layout'
import ShopsView from '@/sections/shops/view/shops-view'

export default function ShopsPage() {
  return (
    <ContentLayout title="ร้านค้า">
      <ShopsView />
    </ContentLayout>
  )
}
